import { RecentSidepanel } from "./recentsidepanel";
import { Fragment, h } from "preact";
import { route } from "preact-router";
import { useState } from "preact/hooks";
import { globalUserState } from "state";
import { Toolbar, ToolIcon, Spacer } from "uitoolkit";

type Props = {
    page?: "chat" | "list" | "profile" | "calendar" | "notes" | "models" | "home";
    isEmptyChat?: boolean;
    conversationId?: string|null;
    loadConversation?: (id: string) => void;
    onPanelToggled?: (open: boolean) => void;
};

export function Sidebar(props: Props) {
    const [showSidebar, setShowSidebar] = useState(false);
    const features = globalUserState.value.user?.features ?? [];
    return (
        <Fragment>
            <Toolbar class="vertical noprint">
                <ToolIcon
                    icon={showSidebar ? "leftpanelclose" : "leftpanelopen"}
                    onClick={() => {
                        setShowSidebar(!showSidebar);
                        props.onPanelToggled?.(!showSidebar);
                    }}
                    selected={showSidebar} />
                {
                    -1 !== features.findIndex(n => n.id == "home") &&
                    <ToolIcon icon="home" href="/home" class={"leftindicator" + (props.page == "home" ? " selected" : "")} />
                }
                <ToolIcon icon="teams-chat" href="/chat" disabled={props.isEmptyChat} class={"leftindicator" + (props.page == "chat" ? " selected" : "")} />
                {
                    -1 !== features.findIndex(n => n.id == "notes") &&
                    <ToolIcon icon="slack-write" href="/note" class={"leftindicator" + (props.page == "notes" ? " selected" : "")} />
                }
                {
                    -1 !== features.findIndex(n => n.id == "calendar") &&
                    <ToolIcon icon="calendar" href="/calendar" class={"leftindicator" + (props.page == "calendar" ? " selected" : "")} />
                }
                {
                    -1 !== features.findIndex(n => n.id == "models") &&
                    <ToolIcon icon="networkintel" href="/models" class={"leftindicator" + (props.page == "models" ? " selected" : "")} />
                }
                <ToolIcon icon="viewlist" href="/content" class={"leftindicator" + (props.page == "list" ? " selected" : "")} />
                <Spacer />
                <ToolIcon icon="avatar" href="/profile" class={"leftindicator" + (props.page == "profile" ? " selected" : "")} />
            </Toolbar>
            {
                showSidebar &&
                <RecentSidepanel
                    conversationId={props.conversationId ?? null}
                    onMessageSelected={props.loadConversation ?? ((id) => route("/chat/" + id!))} />
            }
        </Fragment>
    );
}
